import reframe from 'nike-re-framejs';
import { pushClient } from '@/services/push';
import { handlePushMessage } from './push';

export const tournamentSubscription = pushClient.subscription({
    onMessage: msg => {
        handlePushMessage(msg);
    },
    onSnapshot: snapshot => {
        if (snapshot.length > 0) {
            reframe.dispatch(['nikeone.tournamentSnapshot', snapshot]);
        } else {
            console.error('Invalid sport data from snapshot server.');
        }
    },
    onFailure: () => reframe.dispatch(['nikeone.live.overview.failure'])
});
